import styled from 'styled-components';

export const StyledRecordItemWrapper = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.gradientDark};
  border-radius: ${({ theme }) => theme.radius.small};
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.8rem 1rem;
  padding: 1.6rem 2.4rem;
  height: 9.4rem;

  svg {
    height: 2.4rem;
    path {
      fill: ${({ theme }) => theme.colors.primary.main};
    }
  }

  &[data-type='points'] {
    svg path {
      fill: ${({ theme }) => theme.colors.warning.main};
    }
  }

  p,
  span {
    color: ${({ theme }) => theme.colors.white};
    margin: 0;
  }
`;

export const StyledRecordTitle = styled.p`
  grid-column: 1 / -1;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  min-width: 10.9rem;
`;

export const StyledAvatar = styled.div`
  position: relative;
`;

export const StyledCircleCheck = styled.span`
  align-items: center;
  background-color: ${({ theme }) => theme.colors.primary.main};
  border-radius: 100%;
  bottom: 0;
  display: flex;
  justify-content: center;
  position: absolute;
  right: 0;
  height: 4.3rem;
  width: 4.3rem;

  svg {
    height: 2.4rem;
    path {
      fill: ${({ theme }) => theme.colors.secondary.main};
    }
  }
`;

export const StyledStaticsContent = styled.span`
  font-size: 2.4rem;
  ::first-letter {
    text-transform: uppercase;
  }
`;

export const StyledRedeemTicketsWrapper = styled.div`
  margin-bottom: 2rem;
`;
